import { lazy } from 'react'

const ArqueoCajaGestionApp = lazy(() => import('./view/ArqueoCajaGestion'))
const ArqueoCajaConsultarApp = lazy(() => import('./view/ArqueoCajaConsultar'))

// No se requiere administracion para rol-dominio
export const arqueosCajaRoutesMap = {
  gestion: {
    path: '/arqueo/gestion',
    name: 'Flujo de caja',
    action: 'FLUJO_DE_CAJA',
  },
  consultar: {
    // No registrar en rol-dominio
    path: '/arqueo/consultar/:id',
    name: 'Consultar flujo de caja',
    action: 'CONSULTAR_FLUJO_DE_ARQUEO',
  },
}

const arqueosCajaRoutes = [
  {
    path: arqueosCajaRoutesMap.gestion.path,
    name: arqueosCajaRoutesMap.gestion.name,
    element: <ArqueoCajaGestionApp />,
  },
  {
    path: arqueosCajaRoutesMap.consultar.path,
    name: arqueosCajaRoutesMap.consultar.name,
    element: <ArqueoCajaConsultarApp />,
  },
]
export default arqueosCajaRoutes
